import { render, staticRenderFns } from "./BtcAddressInput.vue?vue&type=template&id=1d3cdb26&scoped=true&"
import script from "./BtcAddressInput.vue?vue&type=script&lang=ts&"
export * from "./BtcAddressInput.vue?vue&type=script&lang=ts&"
import style0 from "./BtcAddressInput.vue?vue&type=style&index=0&id=1d3cdb26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3cdb26",
  null
  
)

export default component.exports